import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { useAuth } from '@/context/AuthContext';
import API from '@/lib/api';

/** Pop-up d'accueil configuré par l'admin, affiché à la connexion selon le rôle (une fois / jusqu'à fermeture). */
export default function OnboardingPopup() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [queue, setQueue] = useState([]);

  useEffect(() => {
    if (!user || user.role === 'admin') { setQueue([]); return; }
    API.get('/my/popups').then(r => setQueue(r.data || [])).catch(() => setQueue([]));
  }, [user?.id, user?.role]); // eslint-disable-line react-hooks/exhaustive-deps

  const current = queue[0];
  if (!current) return null;

  const dismiss = () => {
    API.post(`/my/popups/${current.id}/dismiss`).catch(() => {});
    setQueue(q => q.slice(1));
  };
  const go = (href) => {
    dismiss();
    if (/^https?:\/\//i.test(href)) window.open(href, '_blank', 'noopener'); else navigate(href);
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o) dismiss(); }}>
      <DialogContent className="max-w-lg" data-testid="onboarding-popup">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl flex items-center gap-2" data-testid="onboarding-popup-title">
            <Sparkles className="h-5 w-5 text-brick" /> {current.title}
          </DialogTitle>
          <DialogDescription className="sr-only">Message de bienvenue</DialogDescription>
        </DialogHeader>
        <div className="prose prose-sm max-w-none font-sans text-stone-text [&_ol]:pl-5 [&_ul]:pl-5" dangerouslySetInnerHTML={{ __html: current.body }} data-testid="onboarding-popup-body" />
        <div className="flex flex-col sm:flex-row gap-2 sm:justify-end mt-2">
          <Button variant="ghost" onClick={dismiss} className="rounded-full font-sans" data-testid="onboarding-popup-close">Plus tard</Button>
          {(current.buttons || []).map((b, i) => (
            <Button key={i} onClick={() => go(b.href)} className={`rounded-full font-sans ${i === 0 ? 'bg-brick text-white hover:bg-brick/90' : 'bg-forest text-white hover:bg-forest/90'}`} data-testid={`onboarding-popup-btn-${i}`}>
              {b.label}
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
